module.exports = __webpack_public_path__ + "img/that-picture-base.6c5d50c6.png";